class BogaFavicon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.faviconLinks = document.querySelectorAll(
      'link[rel=icon],link[rel=apple-touch-icon],link[rel="shortcut icon"]'
    );
    this.count = 1;
    setInterval(() => {
      this.updateFiles();
    }, 1000);
  }

  updateFiles() {
    const newCount = this.count === 4 ? 1 : this.count + 1;
    this.faviconLinks.forEach((link) => {
      const href = link.getAttribute('href').replace(`col-${this.count}`, `col-${newCount}`);
      link.setAttribute('href', href);
    });
    this.count = newCount;
  }
}

window.customElements.define('boga-favicon', BogaFavicon);
